<template >
  <v-layout>
    <v-panel
      contextual-style="primary"
    >
      <h1 class="panel-title" slot="heading">
        URL Lookup
      </h1>
      <div slot="body">

<form @submit.prevent="lookupurl(formdata)">
<div class="input-group">
  <div class="input-group-btn">
    <button disabled type="button" class="btn btn-default" aria-label="Help">http(s)://</button>
  </div>
  <input v-model="formdata.url" autofocus class="form-control" aria-label="Text input with multiple buttons">
  <div class="input-group-btn">
    <button @click="lookupurl(formdata)" type="button" class="btn btn-default">Lookup</button>
  </div>
</div>
</form>

<div class="panel panel-default" style="margin-top: 20px" v-if="$store.state.urllookup.url">
  <!-- Default panel contents -->
  <div class="panel-heading"><pre>{{ $store.state.urllookup.url }}</pre></div>

  <table class="table">
    <thead>
      <tr>
        <th>List Name</th>
        <th>List Type</th>
        <th>List Description</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <tr v-bind:class="{'editable': listname.type !== 'global'}"  @click="selectList(listname)" v-for="listname in $store.state.urllookup.lists">
        <td>{{ listname.name }}</td>
        <td>{{ listname.type }}</td>
        <td>{{ listname.description }}</td>
        <td v-bind:class="{ green: listname.enabled, red: !listname.enabled }">{{ listname.enabled ? 'ACTIVE' : 'INACTIVE' }}<span class="readonly" v-if="listname.type === 'global'">&nbsp(readonly)</span></td>
      </tr>
    </tbody>
  </table>

</div>

      </div>
    </v-panel>
  </v-layout>
</template>
<script>

import listService from '../../../services/list';
import store from './../../../store';

export default {
  data() {
    return {
      haveResponse: false,
      formdata: {
        url: null,
      },
    };
  },

  methods: {
    lookupurl(input) {
//      listService.lookupurl(input.url);
      listService.lookupspurl(input.url, store.state.auth.selected_sp.sp_id);
    },
    selectList(newlistid) {
      if (newlistid && newlistid.type) {
        if (newlistid.type === 'global') {
          return;
        }
      }
      const tmpP = {
        listid: newlistid.list_id,
      };
      if (typeof newlistid.skip_to_id !== 'undefined') {
        tmpP.skip_to_id = newlistid.skip_to_id;
      }
      this.$router.push({
        name: 'lists.edit',
        params: tmpP,
      });
    },
  },

  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};

</script>
<style>
tr.editable:hover {
  background: #eeeef2;
  /*cursor:context-menu;*/
  cursor:pointer;
}
td.green {
  color: #00aa00;
}
span.readonly {
  color: #aaaaaa;
}
td.red {
  color: #aa0000;
}
</style>



// WEBPACK FOOTER //
// index.vue?109b16da